
export default {
    API_ENDPOINT: 'https://glacial-ridge-46372.herokuapp.com',
    TOKEN_KEY: 'b0a67ced-e993-4b9a-85f4-7ba2425eec64',
}
